import {create} from 'zustand';
import type {UserDetail} from '@/types/auth';

interface AuthState {
    isLogin: boolean;
    initialized: boolean;
    userInfo: UserDetail | null;
    setIsLogin: (v: boolean) => void;
    setInitialized: () => void;
    setUserInfo: (info: UserDetail | null) => void;
    clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    isLogin: false,
    initialized: false,
    userInfo: null,
    setIsLogin: (v) => set({isLogin: v}),
    setInitialized: () => set({initialized: true}),
    setUserInfo: (info) => set({userInfo: info}),
    clearAuth: () => set({isLogin: false, userInfo: null}),
}));
